import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND } from "lexical";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { Italic } from "lucide-react";

import { useButtonState } from "../useButtonState";

export function ItalicButton() {
    const [editor] = useLexicalComposerContext();
    const isActive = useButtonState(() => {
        const selection = $getSelection();
        return $isRangeSelection(selection) && selection.hasFormat("italic");
    });

    return (
        <button
            type="button"
            className="rte-toolbar-button"
            data-active={isActive}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic")}
            title="Italic"
            aria-label="Italic"
        >
            <Italic size={16} />
        </button>
    );
}
